import type { MemberSummary } from '../types/api.types';
import type { EnrichedMatchResult } from './head-to-head.utils';
import { MatchResultCard } from './match-result-card';
import { formatMemberName } from '../utils/members';

interface ResultsHistoryPanelProps {
  selectedMember: string | number | null;
  sortedMatchResults: EnrichedMatchResult[] | undefined;
  selectedMemberName: string;
  memberEntities: Record<string, MemberSummary>;
}

export function ResultsHistoryPanel({
  selectedMember,
  sortedMatchResults,
  selectedMemberName,
  memberEntities,
}: ResultsHistoryPanelProps) {
  const renderContent = () => {
    if (!selectedMember) {
      return 'Select a player to see match history';
    }

    if (!sortedMatchResults) {
      return 'No history found for selected player';
    }

    return sortedMatchResults
      .map((result, index) => {
        const currentOpponent = result.teamAMember1 === selectedMember ? result.teamBMember1 : result.teamAMember1;
        const currentOpponentDetails = currentOpponent != null ? memberEntities[currentOpponent] : undefined;
        const currentOpponentName = currentOpponentDetails ? formatMemberName(currentOpponentDetails) : '?';

        if (currentOpponent == null) return null;

        return (
          <MatchResultCard
            key={`${result.eventID}-${selectedMember}-${currentOpponent}-${index}`}
            result={result}
            selectedMemberId={selectedMember}
            selectedMemberName={selectedMemberName}
            currentOpponentId={currentOpponent}
            currentOpponentName={currentOpponentName}
            index={index}
          />
        );
      })
      .filter(Boolean);
  };

  return (
    <div style={{ flex: '0 0 40%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '12px',
          background: '#fafafa',
        }}
      >
        {renderContent()}
      </div>
    </div>
  );
}
